import React from 'react';
import { Popover, PopoverSurface, PopoverTrigger } from '@fluentui/react-components';
import { Dismiss16Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';
import { RACI_LEGEND_ITEMS } from './raciConstants';

const legendBadgeClass = value => {
    switch (value) {
        case 'R':
            return styles.raciBadgeR;
        case 'A':
            return styles.raciBadgeA;
        case 'C':
            return styles.raciBadgeC;
        case 'I':
            return styles.raciBadgeI;
        default:
            return styles.raciBadgeBlankLegend;
    }
};

const RaciLegendPopover = () => (
    <Popover trapFocus>
        <PopoverTrigger disableButtonEnhancement>
            <button type="button" className={styles.infoButton} aria-label="RACI legend">
                i
            </button>
        </PopoverTrigger>
        <PopoverSurface className={styles.legendSurface}>
            <div className={styles.legendHeader}>
                <span className={styles.legendTitle}>RACI legend</span>
                <PopoverTrigger disableButtonEnhancement>
                    <button type="button" className={styles.legendClose} aria-label="Close legend">
                        <Dismiss16Regular />
                    </button>
                </PopoverTrigger>
            </div>
            <ul className={styles.legendList}>
                {RACI_LEGEND_ITEMS.map(item => (
                    <li key={item.title} className={styles.legendItem}>
                        <span className={`${styles.raciBadge} ${legendBadgeClass(item.value)} ${styles.raciBadgeLegend}`}>
                            {item.value || '—'}
                        </span>
                        <div>
                            <div className={styles.legendItemTitle}>
                                {item.value ? `${item.value} — ${item.title}` : `— — ${item.title}`}
                            </div>
                            <div className={styles.legendItemDesc}>{item.description}</div>
                        </div>
                    </li>
                ))}
            </ul>
        </PopoverSurface>
    </Popover>
);

export default RaciLegendPopover;
